import React from "react";
import Image from "next/image";
import Input from "./input";
import CardBox from "./card-box";
import ActionIcon from "./action-icon";
import { CircleX, Search } from "lucide-react";

const SearchPrompt = ({
  children,
  handleClick,
  handleSubmit,
  styleOverride,
  title,
  subtitle,
}) => {
  return (
    <CardBox additionalclasses="!p-0 w-full lg:max-w-[655px] rounded-lg  mx-auto">
      <form onSubmit={handleSubmit}>
        <div className="grid grid-flow-col justify-between items-center w-full h-[50px] px-[12px]">
          <ActionIcon color='custom-text-grey-800'>
            <Search size={16} color="currentColor" />
          </ActionIcon>
          <Input
            additionalclasses="!custom-bg-white-50 !border-none !text-[14px] !pl-0 !pr-5 !max-w-full !w-[550px] !poppins-light"
            placeholder="Search"
          />
          <ActionIcon color='custom-text-grey-800' onClick={handleClick}>
            <CircleX size={18} color="currentColor" />
          </ActionIcon>
        </div>
        <div className="grid overflow-y-scroll custom-scrollbar max-h-[500px]">{children}</div>
      </form>
    </CardBox>
  );
};

export default SearchPrompt;
